import { createStyles } from '@mantine/styles';

export default createStyles(() => ({
  base: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
}));
